/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { ParametrosProvider } from "../Parametros/ParametrosContext";

export const AllParametrosProvider = (props) => (
    <ParametrosProvider>
        {props.children}
    </ParametrosProvider>        
);